import { Injectable } from "@angular/core";
import { HttpClient, HttpResponse } from "@angular/common/http";
import { Observable } from "rxjs";
import {
    MonthlyBillableAmount, Subscription, TeamLicenceDetails, YearlySubscription,
    YearlySubscriptionDetailsByTeamDTO
} from "./billing.type";
import { format } from "date-fns-tz";

@Injectable()
export class BillingService {

    constructor (private http: HttpClient) {}

    get_subscription (teamId: string): Observable<HttpResponse<Subscription>> {
        return this.http.get<Subscription>('/api/team/' + teamId + '/subscription', {observe: "response"});
    }

    get_billable_details(teamId: string, countryCode: string, currency: string, vatNumber: string): Observable<MonthlyBillableAmount> {

        let url = `/api/team/${teamId}/monthlyBillableAmount?countryCode=${countryCode}&currency=${currency}`
        if (vatNumber) {
            url = `/api/team/${teamId}/monthlyBillableAmount?countryCode=${countryCode}&currency=${currency}&vatNumber=${vatNumber}`
        }

        return this.http.get<MonthlyBillableAmount>(url);
    }

    add_billing_recipient (teamId: string, recipients: string[]): Observable<Subscription> {
        return this.http.put<Subscription>('/api/team/' + teamId + '/subscription/recipients', recipients);

    }

    isInEU(teamId: string, countryCode: string): Observable<{ isInEu: boolean }> {
        return this.http.get<{ isInEu: boolean }>('/api/team/' + teamId + '/subscription/check_eu/' + countryCode);
    }

    get_yearly_subscription(): Observable<YearlySubscription> {
        return this.http.get<YearlySubscription>('/api/subscription/yearly');
    }

    get_yearly_subscription_details_by_team(month?: Date): Observable<YearlySubscriptionDetailsByTeamDTO> {
        if (month) {
            return this.http.get<YearlySubscriptionDetailsByTeamDTO>( `/api/subscription/yearly/details?month=${format(month, 'MM-yyyy')}`);
        } else {
            return this.http.get<YearlySubscriptionDetailsByTeamDTO>( `/api/subscription/yearly/details`);
        }
    }
}